import useTable from "../../../../MainComponents/Hooks/useTable.jsx";

function SetsTable({ id, tableFor }) {
  const table = useTable(tableFor, "", "", "", "", id);

  return <div className="h-fit w-full">{table}</div>;
}

export default SetsTable;
